import { connect } from "react-redux";
import Overview from "./Overview";
import {
  createPortFolioRequest,
  deletePortfoliosRequest,
  getPortFolioDetails,
  updatePortFolioRequest,
} from "../../../store/actions/portfolio.actions";
import { getClientDetails } from "../../../store/actions/clients.actions";
import {
  portfolio,
  portfolioBudgetSummary as budgetSummary,
  portfolioProgressSummary as progressSummary,
  loading,
  overviewLoader,
} from "../../../store/selectors/portfolio.selector";
import {
  getProgramsRequest,
  createProgramsRequest,
  updateProgramsRequest,
  deleteProgramsRequest,
} from "../../../store/actions/programs.actions";

const mapDispatchToProps = {
  createProgramsRequest,
  updateProgramsRequest,
  deleteProgramsRequest,
  getProgramsRequest,
  getPortFolioDetails,
  getClientDetails,
  createPortFolioRequest,
  updatePortFolioRequest,
  deletePortfoliosRequest,
};

const mapStateToProps = (state) => {
  const portfolioData = portfolio(state);
  const portfolioBudgetSummary = budgetSummary(state);
  const portfolioProgressSummary = progressSummary(state);
  const Loading = loading(state);
  const portfolioLoading = overviewLoader(state);
  return { 
    portfolioData,
    portfolioBudgetSummary,
    portfolioProgressSummary,
    Loading, 
    portfolioLoading };
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
